<div *ngIf="error$ | async as error" class="error-list">
    <div *transloco="let t; read: 'ui.common'" class="error-list__item">
        <div class="error-list__item__text" [innerHTML]="t('defaultError')">
        </div>
        <button class="error-list__item__close" (click)="dismiss(error)"></button>
    </div>
</div>
